export const ucApi = (defHttp) => ({
  // 获取当前用户信息
  getCurrent: (params: { appCode: string }) => {
    return defHttp.get({ url: '/uc/current', params });
  },
});

export const ucLoginApi = (defHttp) => ({
  // 刷新token
  refreshToken(params: { refreshToken: string }) {
    defHttp.setHeader({
      Authorization: '',
    });
    return defHttp.post({
      url: `/uc/login/refresh`,
      params,
    });
  },

  // code换token
  codeToToken: (params: { authorizationCode: string; clientId: string }) => {
    return defHttp.post({ url: `/uc/login/token`, params });
  },
});

export const ucOrgsApi = (defHttp) => ({
  // 切换租户
  selectOrg(params: { orgId: string; refreshToken: string; accessToken: string }) {
    return defHttp.post({ url: `/uc/orgs/switch`, params });
  },
});

export const aiadEmsApi = (defHttp) => ({
  // 当前租户信息
  getOrgCurrent: () => {
    return defHttp.get({
      url: `/aiad/ems/orgs/current`,
    });
  },
});

export const tcWechatApi = (defHttp) => ({
  // 获取openid
  openId: (params: { code: string }) => {
    return defHttp.get({
      url: `/tc/wechat/openid`,
      params,
    });
  },

  // 获取微信初始化sdk参数
  getWechatSdkInitParams: (params: { url: string }) => {
    return defHttp.get({
      url: `/tc/wechat`,
      params,
    });
  },
});
